import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/builds/macys/polaris/nuxt-app/post-purchase/app/layouts/default.vue").then(m => m.default || m)),
  "full-container": defineAsyncComponent(() => import("/builds/macys/polaris/nuxt-app/post-purchase/app/layouts/full-container.vue").then(m => m.default || m))
}